import React, { FC } from 'react';

import { Box } from '@mui/material';

import { styles } from './styles';
import { IStoryMessage } from '@bus/storyTeller/typedefs';
import PromptLists from '@components/pages/private/StoryTellerPage/PromptLists';
import StoryItem from '@components/pages/private/StoryTellerPage/StoryItem';
import ErrorState from '@components/pages/private/StoryTellerPage/ErrorState';

type StoriesListProps = {
  stories: IStoryMessage;
  currentChatId: number;
};

export const StoriesList: FC<StoriesListProps> = ({
  stories,
  currentChatId,
}) => {
  return (
    <Box sx={styles.storiesList}>
      <Box id={'story-anchor'} />
      {stories.status === 'error' ? (
        <ErrorState currentChatId={currentChatId} />
      ) : (
        <Box sx={styles.wrapper}>
          {!!stories.prompts.length &&
            stories.prompts.some((item) => !item.isSkeleton) && (
              <PromptLists message={stories} />
            )}
          {!!stories.prompts.length &&
            stories.prompts.map((prompt, index) => (
              <StoryItem
                key={prompt.id}
                story={prompt}
                index={index}
                messageId={stories.id}
                ratio={stories.image_size}
                chatId={stories.chat}
                regenerateLimit={stories.prompt_image_regenerated}
              />
            ))}
        </Box>
      )}
    </Box>
  );
};

export default StoriesList;
